import { request } from '../core';
import { Method } from '../core/util';
export default class ControlCommandApi {
  /**
   * 下发无保护左转指令
   * @param {Object} param 参数对象
   * @param {string} param.vehicleName 车号
   * @param {string[]} param.groupLaneIdList 左转线段ID
   * @param {string} param.timeStamp 时间
   * @return {Promise}
   */
  public controlNoSignalIntersection = (param: {
    vehicleName: string;
    groupLaneIdList: string[];
    timeStamp: string;
  }): Promise<any> => {
    return request({
      method: Method.POST,
      path: '/monitor/web/command/pass_no_signal_intersection',
      body: param,
    });
  };

  /**
   * 通过/取消通过红绿灯路口
   * @param {Object} param 参数对象
   * @param {string} param.vehicleName 车号
   * @param {number[]} param.trafficLightId 红绿灯Id
   * @param {string} param.timeStamp 时间戳
   * @param {boolean} param.passThrough 通过、取消
   * @return {Promise}
   */
  public sendTraficLightCommand = (param: {
    vehicleName: string;
    trafficLightId: number[];
    timeStamp: string;
    passThrough: boolean;
  }): Promise<any> => {
    return request({
      method: Method.POST,
      path: '/monitor/web/command/control_traffic_light',
      body: param,
    });
  };
}
